/**
 * @file Identity Update action.
 */

import axios from 'axios';

import { photoUploadSuccess } from './photo-upload';
import getLogger from '../util/logger';
import { getErrorString } from '../util/normalize-errors';

const log = getLogger('IdentityUpdateAction');

export const IDENTITY_UPDATE_REQUEST = 'identity/UPDATE_REQUEST';
export const IDENTITY_UPDATE_SUCCESS = 'identity/UPDATE_SUCCESS';
export const IDENTITY_UPDATE_FAILURE = 'identity/UPDATE_FAILURE';
export const IDENTITY_UPDATE_RESET = 'identity/UPDATE_RESET';

const identityUpdateRequest = () => {
  return { type: IDENTITY_UPDATE_REQUEST };
};

const identityUpdateSuccess = identity => {
  return { type: IDENTITY_UPDATE_SUCCESS, identity };
};

const identityUpdateFailure = error => {
  return { type: IDENTITY_UPDATE_FAILURE, error };
};

const identityUpdateReset = () => {
  return { type: IDENTITY_UPDATE_RESET };
};

export const identityUpdate =
  (
    accountId,
    identity,
    identityFirstName,
    identityLastName,
    file,
    photosUploadMutation,
    identityUpdateMutation,
    updateSelfieMutation,
  ) =>
  async dispatch => {
    log.info('identityUpdate() :: Updating identity...', identity.id);

    if (!identityFirstName && !identityLastName && !file) {
      return;
    }

    dispatch(identityUpdateRequest());

    try {
      if (identityFirstName || identityLastName) {
        const identityUpdateRes = await identityUpdateMutation(
          identity.id,
          identityFirstName,
          identityLastName,
        );

        if (!file) {
          log.info('identityUpdate() :: Identity name updated');
          const { identity: updatedIdentity } =
            identityUpdateRes.data.identityUpdate;
          dispatch(identityUpdateSuccess(updatedIdentity));
          return;
        }
      }

      const photoUploadsRes = await photosUploadMutation(accountId, [
        { filename: file.name, content_type: file.type },
      ]);

      const photoUploadData =
        photoUploadsRes.data.photosUpload.photo_uploads[0];
      const photoId = photoUploadData.photo_id;

      await axios.put(photoUploadData.upload_url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      const updateSelfieRes = await updateSelfieMutation(identity.id, photoId);

      dispatch(
        photoUploadSuccess(
          { id: photoId, identityId: identity.id, file },
          true,
        ),
      );

      const { identity: updatedIdentity } = updateSelfieRes.data.updateSelfie;

      log.info('identityUpdate() :: Identity updated');

      dispatch(identityUpdateSuccess(updatedIdentity));
    } catch (error) {
      log.error('identityUpdate() :: Error:', error);

      dispatch(identityUpdateFailure(getErrorString(error)));
    }
  };

export const identityUpdateResetAction = () => dispatch => {
  dispatch(identityUpdateReset());
};
